module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADMAAAAzCAYAAAA6oTAqAAAACXBIWXMAAAsSAAALEgHS3X78AAABNUlEQVRoge3W223CQBCF4ZlUQAkpgVJSgktJB5QQUQElUALpIHQAHRxktJYG48veHMbo/JLf1rPzWTwgjDHGGGNsvQH4BHAAcAKwA7CpgQHwDeAYnu2/fKAAsZ1KQQB+ejMv9TaevvgPz2WDBiD36m+ecHkOaGrWcoLHBTZh8SJQzY9SVCnIDcQslAVyBzGLJYHcQsyCUSD3kK4I0DogXTOg9UC6EkC+IV0RoMUgH7UHqupVRPYTR/bhjP8ANBE/s+ZdIP5BE5BLeNYBmoFsw+MfNAcx53yDYiHmvE9QKsS85wuUCzHv+wAB+CqBmDmvB438VUmCmFmjoGW2f16gj8mCmHmDoLpbj1/e1IKYmX3QLmeO5l4uIu0/37OqnnNmDMxs57Vzr6r6W2MmY4wxxhh7USJyA0UvSSbMiSTvAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/app/code/btn_close.png
// module id = 359
// module chunks = 1